import type { ReactElement, ReactNode } from 'react';
import Tooltip, { TooltipTrigger, TooltipContent } from '../../Overlays/Tooltip';

interface WithTooltipProps {
    content: ReactNode;
    className?: string;
    focusable?: boolean;
    children: ReactElement;
}

const WithTooltip = ({ content, className, focusable, children }: WithTooltipProps) => (
    <Tooltip>
        <TooltipTrigger className={className} focusable={focusable}>
            {children}
        </TooltipTrigger>
        <TooltipContent>{content}</TooltipContent>
    </Tooltip>
);

export default WithTooltip;
